module.exports = __webpack_public_path__ + "static/Bright@2x.028b7273.png";